import styled from 'styled-components'

const Form = styled.form`
  display: grid;
  grid-row-gap: 2rem;
  grid-template-areas:
    'heading'
    'form'
    'footer';
`

export default Form



// WEBPACK FOOTER //
// ./src/Patients/components/AddPatientForm.js